import { ForestOwnerSandboxDocuments } from '@features/Framework/ForestOwnerSandbox/ForestOwnerSandboxDocuments'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/framework/forestowner/$forestownerId/documents')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Dokumenter',
  },
})

function RouteComponent() {
  const { forestownerId } = Route.useParams()
  return <ForestOwnerSandboxDocuments forestownerId={forestownerId} />
}
